import { render } from "./BuildingWorkMonthlyBillingEmailCreate.vue?vue&type=template&id=3d6f4978&scoped=true"
import script from "./BuildingWorkMonthlyBillingEmailCreate.vue?vue&type=script&lang=js"
export * from "./BuildingWorkMonthlyBillingEmailCreate.vue?vue&type=script&lang=js"

import "./BuildingWorkMonthlyBillingEmailCreate.vue?vue&type=style&index=0&id=3d6f4978&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d6f4978"]])

export default __exports__